module.exports = __webpack_public_path__ + "img/102267.f382f74e.svg";